export const contactsData = {
  email: 'hirenhdhadhal@gmail.com',
  phone: '+91-8460712269',
  address: 'Ahmedabad, Gujarat, India 380059',
};
